import styled from 'styled-components';

const Block = styled.div`
  flex: 1;
  height: 100%;
  overflow: auto;
`;

export default Block;
